// Rails stuff
require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();

// Jquery
import jquery from "jquery";

window.$ = window.jquery = jquery;
window.jQuery = window.jquery = jquery;

// Common Lib
require("packs/libs/jquery-ui");
require("packs/libs/jquery-ui.multidatespicker");
require("moment");
require("bs-rating");
import "bootstrap";
import "select2";
require("bootstrap-timepicker");

// Amplitude
import amplitude from "amplitude-js";
global.AmplitudeModule = amplitude;

global.Papa = require("papaparse");

// AngularJs
global.bootbox = require("bootbox");
global.toastr = require("toastr");
global.angular = require("angular");
require("packs/base/init");
require("packs/base/angular_app");
require("packs/base/angular_utils");
require("angular-route");
require("angular-nvd3");
require("angular-sanitize");

global.app = angular.module("app");
require("packs/pages/user_dashboard_ctrl");
require("packs/pages/credit_card_ctrl");
require("packs/pages/pay_installment_ctrl");
require("packs/libs/owl.carousel.min");
require("packs/pages/admin/seating_section_layout_map_ctrl");
require("packs/pages/admin/evidence_api");
require("packs/pages/admin/custom_payment_plan_ctrl");
window.ClipboardCopy = require("packs/pages/copy").default;
